import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import BuddibleSocket, { MsgIDList } from "../../../lib/BuddibleSocket";
import Utilities from "../../../lib/Utilities";
import CodeList from "../../../lib/CodeList";

const socket = new BuddibleSocket();
const util = new Utilities();
const codeList = new CodeList();
const _mClassName = "ChangeChatRoomTitleModal";

export default function ChangeChatRoomTitleModal(props) {
  const { loginInfo } = props;
  const { t } = useTranslation();
  const [data, setData] = useState(null);
  const inputRef = useRef();

  useEffect(() => {
    socket.addLocalEventListener(
      MsgIDList.EVENT_CHANGE_CHAT_ROOM_TITLE_MODAL_CALL,
      _mClassName,
      (b, n) => {
        setData(n);
      }
    );

    return () => {
      socket.removeLocalEventListener(
        MsgIDList.EVENT_CHANGE_CHAT_ROOM_TITLE_MODAL_CALL,
        _mClassName
      );
    };
  }, []);

  function closeModal() {
    if (inputRef.current) inputRef.current.value = "";
    setTimeout(() => {
      setData(null);
    }, 300);
  }

  function save() {
    if (data === null) {
      codeList.Modal.current.alert(t("commonMSG.error"));
      return;
    }
    const msgID = util.makeUUIDv4();
    const _data = {
      method: MsgIDList.EVENT_TALK_CHAT_ROOM_TITLE_CHANGE,
      msgID: msgID,
      data: {
        cruRoomName: inputRef.current.value, //사용자지정 룸네임
        cruMainKey: data.crmMainKey, //방키
        cruUserSite: loginInfo.comp_cd, //사용자compcd
        cruUserID: loginInfo.user_id, //user id},
      },
    };

    socket.sendSocketMessage(_data, msgID, (beforeData, newData) => {
      if (newData) {
        if (newData.ret) {
          codeList.Modal.current.alert(t("commonMSG.success"), () =>
            document.querySelector("#ChangeChatRoomTitleModalClose").click()
          );
          socket.fireLocalEventListener(
            MsgIDList.EVENT_TALK_CHAT_ROOM_TITLE_CHANGE,
            _mClassName,
            _data.data,
            () => {}
          );
        }
      }
    });
  }

  return (
    <div
      className="modal fade"
      id="ChangeChatRoomTitleModal"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      aria-labelledby="ChangeChatRoomTitleModal"
      data-backdrop="static"
      data-keyboard="false"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-sm modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header border-0">
            <p className="font-weight-bold">
              {t("logiTalk.chatList.chatRoomTitle")}
            </p>
            <i
              className="fas fa-plus fa-times cursor_pointer"
              data-dismiss="modal"
              aria-label="Close"
              id="ChangeChatRoomTitleModalClose"
              onClick={closeModal}
            />
          </div>

          <div className="modal-body">
            {data !== null && (
              <>
                <input
                  type="text"
                  ref={inputRef}
                  className="form-control mb-3"
                  placeholder={`${t("logiTalk.chatList.before")}) ${
                    data.chatRoomTitle
                  }`}
                />
                <div className="text-right">
                  <button
                    className="btn btn-sm btn-outline-info"
                    onClick={() =>
                      document
                        .querySelector("#ChangeChatRoomTitleModalClose")
                        .click()
                    }
                  >
                    {t("logiTalk.chatList.cancel")}
                  </button>
                  <button className="btn btn-sm btn-info ml-2" onClick={save}>
                    {t("logiTalk.chatList.save")}
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
